import { render } from "./DatasetEdit.vue?vue&type=template&id=f4903f66"
import script from "./DatasetEdit.vue?vue&type=script&lang=js"
export * from "./DatasetEdit.vue?vue&type=script&lang=js"

import "./DatasetEdit.vue?vue&type=style&index=0&id=f4903f66&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/ddv-home/DatasetEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f4903f66"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f4903f66', __exports__)) {
    api.reload('f4903f66', __exports__)
  }
  
  module.hot.accept("./DatasetEdit.vue?vue&type=template&id=f4903f66", () => {
    api.rerender('f4903f66', render)
  })

}


export default __exports__